import { useCallback } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { createStructuredSelector } from 'reselect';
import { AuthActions } from 'store/actions';
import { AuthSelectors } from 'store/selectors';
import AuthModal from 'components/auth/AuthModal';
import { safeSessionStorage } from 'utils/safeStorage';
import useModal from './useModal';

const stateSelector = createStructuredSelector({
  isAuthenticated: AuthSelectors.isAuthenticated,
  isHardUser: AuthSelectors.isHardUser,
  isAdmin: AuthSelectors.isAdmin,
  isMarketAdmin: AuthSelectors.isMarketAdmin,
  isSuperAdmin: AuthSelectors.isSuperAdmin,
  currentUser: AuthSelectors.currentUser,
});

const useAuthProps = () => {
  const dispatch = useDispatch();
  const [showAuthModal] = useModal(AuthModal);
  const { isAuthenticated, isHardUser, isAdmin, isMarketAdmin, isSuperAdmin, currentUser } = useSelector(stateSelector);

  const onLogin = useCallback(() => {
    showAuthModal();
  }, [showAuthModal]);

  const onLogout = useCallback(() => {
    safeSessionStorage.removeItem('marketInitiated');
    dispatch(AuthActions.logout());
    safeSessionStorage.setItem('shownNudgeToLoginPopover', String(true));
  }, [dispatch]);

  return {
    isAuthenticated,
    isHardUser,
    isAdmin,
    isMarketAdmin,
    isSuperAdmin,
    currentUser,
    onLogin,
    onLogout,
  };
};

export default useAuthProps;
